export default {
  title: '安防计算器',
  common: {
    reset: '重置',
    compute: '计算',
    result: '计算结果:',
    day: '天',
    hour: '小时',
    days: '天',
    hours: '小时',
    meter: '米',
    feet: '英尺',
    millimeter: '毫米',
    channel: '路',
    watt: '瓦',
    Box:'箱',
    pleaseEnter: '请输入',
    pleaseChoose: '请选择',
    resultNote: '(计算结果仅供参考)',
    to: '到',
    streamReference: '常见分辨率、码率关系对照参考表（仅供参考）',
    resolution: '分辨率',
    stream: '码流',
    yes:'是',
    no:'否',
    length:'长度',
    width:'宽度',
    column: '列',
    row: '行',
    inch: '寸',
    number: '数量',
    area: '面积',
    unit: '单位',
    productName: '产品名称',
    productList: '产品清单图',
    /* unit: '单位', */
    productUnit: {
      screen: '块',
      imageProcess: '套',
      dviWire: '条',
      batteryCabinet: '台',
      camera: '台',
      power: '个',
      battery: '只',
      cable: '根',
    }
  },
  lens: {
    common: '镜头计算',
    focus: '焦距',
    objectDistance: '物体距离',
    objectWidth: '物体宽度',
    sensorWidth: '传感器尺寸',
    lensFocus: '镜头焦距',
  },
  capacity: {
    common: '容量计算',
    videoSize: '录像大小',
    recordTime: '录像时间',
    diskArray: '磁盘阵列',
    custom: '自定义',
    bitRate: '选择码率',
    customRate: '自定义码率',
    cameraNum: '摄像头个数',
    storageDay: '存储天数',
    totalDiskSize: '磁盘总容量',
    driver: '设备驱动',
    raid: '磁盘阵列卷',
    diskSize: '磁盘容量',
    availableSize: '有效容量',
    driverList: {
      8: '8盘位',
      16: '16盘位',
      24: '24盘位',
      36: '36盘位',
      48: '48盘位'
    },
    resultSeperator1: '', //录像时间计算结果中数值和单位之前的间隔
    resultSeperator2: ' '//录像时间计算结果中天和小时之间的间隔
  },
  ip: {
    common: 'IP计算',
    hostIp: '主机IP',
    maskBits: '掩码位',
    networkAddr: '当前网络',
    netmaskAddr: '子网掩码',
    hostRange: '主机范围',
    host: '主机',
    mask: '掩码',
    subnet: '子网',
    broadcastAddr: '广播地址',
    ipPlaceholder: '— — —'
  },
  NVRModel: {
    common: 'NVR系列功能选型'
  },
  twistedPair: {
    common: '双绞线用量计算',
    Locations:'点位数',
    cableSpecifications:'线缆选择',
    cableList: {
      100: '100米/箱',
      305: '305米/箱',
    },
    result: {
      note: '工程使用每箱{field}的线缆数量为:'
    },
    placeholder:'最远的设备离弱电井的距离范围为1-100米'
  },
  splicingScreen: {
    common: '拼接屏计算',
    calculateType: '计算方式',
    columns: '列数',
    rows: '行数',
    height: '拼接屏高度',
    width: '拼接屏宽度',
    screenType: '屏幕类型',
    screenSize: '屏幕大小',
    method: '安装方法',
    dviWire: 'DVI线材',
    imageProcessUnit: '图像处理单元',
    lcdUnit: 'LCD液晶拼接屏单元',
    screenBase: '落地式拼接屏底座',
    methodValue: '底座式',
    result: {
      splicingScreen: '所需拼接屏:',
      area: '所占面积:',
      height: '高度为:',
      width: '宽度为:'
    }
  },
  ups: {
    common: 'UPS计算',
    batteryCabinet: '电池机柜',
    totalPower: '设备总功率',
    backupTime: '所需后备时间',
    result: {
      upsCapacity: 'UPS容量',
      batteryCapacity: '蓄电池容量'
    }
  },
  cameraPower: {
    common: '摄像机电源计算',
    gunCamera: '枪型摄像机',
    irGunCamera: '红外枪型摄像机',
    domeCamera: '半球摄像机',
    irDomeCamera: '红外半球摄像机',
    ballCamera: '普通球形摄像机',
    irBallCamera: '红外球形摄像机',
    supplyMode: '电源供电方式',
    independentSupply: '独立供电',
    result: {
      power: '所需的功率约为:',
      independentSupply: '所需的独立供电为:'
    }
  },
  cameraFocalLength: {
    common: '摄像机焦距'
  },
  cable: {
    common: '桥架容量计算',
    cableType: '线缆型号',
    bridgeSpec: '桥架规格',
    bridgeHeight: '桥架高度',
    bridgeWidth: '桥架宽度',
    customSpec: '自定义规格',
    coaxCable: '同轴线缆',
    typeList: {
      standardFive: '国标超五类',
      companyStandardFive: '大华企标超五类',
      shieldStandardFive: '国标超五类(屏蔽)',
      standardSix: '国标六类',
      companyStandardSix: '大华企标六类',
      shieldStandardSix: '国标六类(屏蔽)'
    },
    result: {
      cableNumber: '可放线缆数量:'
    }
  },
  RVVWire: {
    common: 'RVV线计算'
  },
  bandwidthCalculator:{
    common:'带宽计算',
    numberOfDevices:'设备数量',
    encodingType:'编码类型',
    recommendedBitRate:'推荐码率',
    result:'所需带宽约为：',
    deviceType:'设备类型'
  },
  switchAccessCalculator:{
    common:'交换机接入计算',
    numberOfConnectedIPCs:'接入IPC',
    numberOfSwitches:'接入交换机',
    operatingEnvironment:'使用环境',
    environment:{
      indoor:'室内',
      outdoor:'室外'
    },
    PoE:'是否支持PoE',
    opticalPort:'是否支持光口',
    switchType:'交换机类别',
    switchModel:'交换机型号',
    switchTypes:{
      coreSwitch:'核心交换机',
      100:'百兆接入交换机',
      1000:'千兆接入交换机'
    },
    IPCBitRate:'IPC码率大小',
    numberofIPCs:'IPC数量',
    ePOE:'是否支持ePOE',
    longDistanceTransmission:'是否支持远程传输',
    resultNote: '注：请自行计算需要的交换机数量',
    result: {
      IPC: '可接入{field}的IPC个数为:',
      switch: '推荐使用的交换机型号及路数为:',
      core:"可接入的IPC个数为:"
    }
  },
  intelligentWirelessSolution:{
    common:'无线智能方案',
    bridge:'网桥',
    location:'使用场景',
    outdoorBridge:'室外网桥',
    elevatorBridge:'电梯网桥',
    AP:'AP/路由器',
    outdoorAp:'室外AP',
    indoorAp:'室内AP',
    rooms:'房间数',
    square:'广场',
    hall:'餐厅/大厅',
    room:'房间',
    numberOfBridges:'网桥数量',
    pointToMultipoint:'点对多点',
    pointToPoint:'点对点',
    inputNumOfIPC:'请输入IPC数量',
    inputNumOfRooms:'请输入房间数量',
    inputLengthOfRooms:'请输入房间长度',
    inputWidthOfRooms:'请输入房间宽度',
    inputWidthOfSquare:'请输入广场宽度',
    inputLengthOfSquare:'请输入广场长度',
    roomLength:'房间长度',
    roomWidth:'房间宽度',
    squareWidth:'广场宽度',
    squareLength:'广场长度',
    IPCbite:'IPC码流',
    IPCnum:'IPC数量',
    transmissionDistance:'传输距离',
    frequencyBand:'工作频段',
    deviceType:'产品类型',
    deviceModel:"产品型号", // Device Model
    deviceTotal:"产品数量",
    deviceList:"产品清单",
    AccessController:'配套AC',
    resultTips:'提示:列表中的方案请任选其一',
    resultTips2:'提示:列表中的路由器或是AP请任选其一',
    resultTips3:'本结果仅对应录入数据，如与实际情况冲突时，请以实际情况为准',
    resultTips4:'如在采购、安装、运行过程中遇到问题，请联系当地的大华相关人员寻求支持',
    solution:'方案',
    netBridgeClient:'客户端',
    netBridgeStation:'基站',
    matchingType:'适配类型'
    // Total Devices
  },
  error: {
    emptyCameraNum: '请输入摄像头个数',
    emptyStorageDay: '请输入存储天数',
    emptyTotalDiskSize: '请输入磁盘总容量',
    emptyCustomRate: '请输入自定义码率',
    emptyIP: '请输入主机IP',
    illegalIP: '请输入合法主机IP地址',
    emptyMask: '请输入掩码位',
    emptyObjectDistance: '请输入物体距离',
    emptyObjectWidth: '请输入物体宽度',
    emptyDeviceNum: '请输入设备数量',
    emptySwitchModel: '请选择交换机型号',
    emptyLmax:'请输入设备离弱电井的距离',
    emptyPoint:'请输入点位数',
    numberofIPCs:'请输入IPC数量',
    cannotBeZero: '{field}不能为0',
    noType: '暂无推荐型号',
    emptySplicingScreenHeight: '请输入拼接屏高度',
    emptySplicingScreenWeight: '请输入拼接屏宽度',
    emptySplicingScreenColumn: '请输入拼接屏列数',
    emptySplicingScreenRow: '请输入拼接屏行数',
    emptyTotalPower: '请输入设备总功率',
    emptyBackupTime: '请输入后备所需时间',
    emptyCameraType: '请至少选择一个摄像机类型',
    emptyBridgeWidth: '请输入桥架宽度',
    emptyBridgeHeight: '请输入桥架高度'
  },
  info: {
    comingSoon: '后续更多工具敬请期待'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js